












import { Component, Vue } from "vue-property-decorator";

import { UserService } from "@/core/services";
import { WorkshopUserModel } from "@/core/models";

@Component
export default class GreetingMessageCpt extends Vue {
  userWorkshop?: WorkshopUserModel;
  loading = true;

  async created() {
    this.userWorkshop = await UserService.getUserWorkshopDetails();
    this.loading = false;
  }

  get title() {
    if (this.userWorkshop) {
      return `Hello ${this.userWorkshop.fullName} from ${this.userWorkshop.companyName}`;
    }
    return "";
  }
}
